import { APP_BREAKPOINTS } from 'constants/appConfig';
import { MICROSITES_NAMES } from 'constants/appName';
import { isTrue } from 'utils/varValidation';
import qs from 'store/entities/QueryString';

const { XS } = APP_BREAKPOINTS;

export const getMetaTags = () => document.getElementsByTagName('meta');

export const getMetaTagContent = (type, valueType) => {
  const metas = getMetaTags();
  let i = 0;
  for (i; i < metas.length; i++) {
    if (metas[i].getAttribute(type) === valueType) {
      return metas[i].content;
    }
  }
  return null;
};

export const getMetaTagContentByType = valueType =>
  getMetaTagContent('type', valueType) || null;
export const getMetaTagContentByName = valueType =>
  getMetaTagContent('name', valueType) || null;

export const isInsideIFrame = () => {
  try {
    const isFramedXtcon = window.parent !== window.top;
    const isFramedStaticHosting = window.location !== window.parent.location;
    if (isStaticHosted()) {
      return isFramedStaticHosting;
    } else {
      return isFramedXtcon;
    }
  } catch (e) {
    return true;
  }
};

export const isIE = document.documentMode;
export const isEdge = /Edge/.test(navigator.userAgent);
export const isFirefox = typeof InstallTrigger !== 'undefined';
export const isIEorEdge = isIE || isEdge;
export const isIOS =
  /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

export const isMobile = () => window.innerWidth < XS;

export const isMicrosite = () => {
  const appName = `${getMetaTagContentByName('xtime:appName')}`;
  return MICROSITES_NAMES.indexOf(appName) > -1;
};

export const isStaticHosted = () => {
  return isTrue(getMetaTagContentByName('xtime:staticHosting'));
};

export const getS3Domain = () => {
  return getMetaTagContentByName('xtime:staticHostingUrl');
};

export const setLanguageTag = locale => {
  if (locale) {
    const htmlTag = document.getElementsByTagName('html')[0];
    htmlTag.setAttribute('lang', locale.split('_')[0]);
  }
};

export const useMicrositeStaticUrl = () => {
  const isProd = process.env.NODE_ENV === 'production';
  return isProd && (isStaticHosted() || isMicrosite());
};

export const getSchemaDomain = () => {
  return `//${getMetaTagContentByName('xtime:consumerEndpoint')}`;
};
export const getBaseUrl = () => {
  const endpoint = `${getMetaTagContentByName('xtime:consumerEndpoint')}`;
  const isMicrositeProd = useMicrositeStaticUrl();
  return isMicrositeProd ? `//${endpoint}/xws` : '/xws';
};

export const isAbsoluteURL = url => {
  const pat = /^(https?:)?\/\//i;
  return pat.test(url);
};

export const resetScrollPosition = scrollY => {
  qs.get('vmode') === 'modal'
    ? document.getElementsByClassName('framed-modal')[0].scrollTo(0, scrollY)
    : window.scrollTo(0, scrollY);
};



// WEBPACK FOOTER //
// ./src/utils/DOM.js